export const PhoneAnalyticsFeatureFlags = {
  demoData: 'phone-analytics-demo-data',
  featureEnabled: 'phone-reporting-enabled',
} as const;
